module.exports = __webpack_public_path__ + "media/images/cards/diners_club-1aa43e7d1d4f0a527af30186ad2397d4.png";